<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="building-06">
      <path
        id="Icon"
        d="M15.4692 14.6667H9.06924C7.57576 14.6667 6.82903 14.6667 6.2586 14.9573C5.75683 15.213 5.34888 15.6209 5.09322 16.1227C4.80257 16.6931 4.80257 17.4399 4.80257 18.9333V28M28.8026 28V8.26667C28.8026 6.77319 28.8026 6.02646 28.5119 5.45603C28.2563 4.95426 27.8483 4.54631 27.3465 4.29065C26.7761 4 26.0294 4 24.5359 4H19.7359C18.2424 4 17.4957 4 16.9253 4.29065C16.4235 4.54631 16.0156 4.95426 15.7599 5.45603C15.4692 6.02646 15.4692 6.77319 15.4692 8.26667V28M30.1359 28H3.46924M20.1359 9.33333H24.1359M20.1359 14.6667H24.1359M20.1359 20H24.1359"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
